export default __webpack_public_path__ + "static/19-bfb68587067fb307b631df8f4557d763.jpg";